
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Contact() {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (formData.message.length > 500) return;
    setStatus('sending');
    try {
      const body = new URLSearchParams({
        name: formData.name,
        email: formData.email,
        message: formData.message,
      });
      const res = await fetch('https://readdy.ai/api/form/d6jb8brcs59vsrrrjvb0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });
      if (res.ok) {
        setStatus('success');
        setFormData({ name: '', email: '', message: '' });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="min-h-screen bg-[#1a1a2e] text-white font-['Orbitron'] flex flex-col">
      {/* Header */}
      <header className="p-4 flex items-center border-b border-white/10">
        <Link
          to="/"
          className="flex items-center gap-2 text-[#fbbf24] hover:text-[#f59e0b] transition-colors cursor-pointer"
        >
          <i className="ri-arrow-left-line text-xl"></i>
          <span className="text-sm">홈으로</span>
        </Link>
      </header>

      {/* Content */}
      <main className="flex-1 overflow-y-auto px-6 py-8 pb-safe">
        <div className="max-w-2xl mx-auto">
          <h1 className="text-3xl font-bold text-[#fbbf24] mb-2">Contact</h1>
          <div className="w-12 h-1 bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] rounded-full mb-8"></div>

          <p className="text-gray-300 leading-relaxed mb-6">
            문의사항이나 제안사항이 있으시면 아래 이메일로 연락주세요.
          </p>

          <a
            href="mailto:naholoceo12@naver.com"
            className="inline-flex items-center gap-2 text-[#fbbf24] hover:text-[#f59e0b] transition-colors mb-10 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-line text-base"></i>
            </div>
            <span className="text-sm">naholoceo12@naver.com</span>
          </a>

          <p className="text-gray-300 leading-relaxed mb-6">
            또는 아래 양식으로 문의해주세요
          </p>

          <form
            data-readdy-form
            id="contact-form"
            onSubmit={handleSubmit}
            className="space-y-5"
          >
            <div>
              <label className="block text-sm text-gray-300 mb-2">이름</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="홍길동"
                required
                className="w-full bg-white/5 border border-white/20 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#fbbf24] transition-colors"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-300 mb-2">이메일</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="example@email.com"
                required
                className="w-full bg-white/5 border border-white/20 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#fbbf24] transition-colors"
              />
            </div>

            <div>
              <label className="block text-sm text-gray-300 mb-2">문의 내용</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="문의 내용을 입력해주세요. (최대 500자)"
                required
                maxLength={500}
                rows={5}
                className="w-full bg-white/5 border border-white/20 rounded-lg px-4 py-3 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#fbbf24] transition-colors resize-none"
              />
              <p className="text-right text-xs text-gray-500 mt-1">{formData.message.length} / 500</p>
            </div>

            {status === 'success' && (
              <div className="bg-green-500/10 border border-green-500/30 rounded-lg px-4 py-3 text-green-400 text-sm">
                문의가 성공적으로 전송되었습니다. 감사합니다!
              </div>
            )}
            {status === 'error' && (
              <div className="bg-red-500/10 border border-red-500/30 rounded-lg px-4 py-3 text-red-400 text-sm">
                전송 중 오류가 발생했습니다. 다시 시도해 주세요.
              </div>
            )}

            <button
              type="submit"
              disabled={status === 'sending' || formData.message.length > 500}
              className="w-full py-4 rounded-lg font-bold text-white text-base bg-gradient-to-r from-[#a855f7] to-[#ec4899] hover:opacity-90 transition-opacity disabled:opacity-50 cursor-pointer whitespace-nowrap"
            >
              {status === 'sending' ? '전송 중...' : '문의 보내기'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
}
